import { useMemo } from "react";

const useProductComparisonActions = ({
  product,
  alternatives,
  selectedProducts,
  addProduct,
  navigate,
  onTrackCompare,
  showToast,
}) => {
  const maxComparableCount = 5;

  const topAlternatives = useMemo(() => alternatives || [], [alternatives]);

  const tryAdd = (item, added) => {
    if (!item?._id) return added;
    if (selectedProducts.length + added >= maxComparableCount) return added;
    if (selectedProducts.some((p) => p._id === item._id)) return added;
    addProduct(item);
    return added + 1;
  };

  const addCurrentProduct = () => tryAdd(product, 0);

  const addForCompare = () => {
    if (!product) return 0;

    let added = addCurrentProduct();
    topAlternatives.slice(0, 3).forEach((item) => {
      added = tryAdd(item, added);
    });

    return added;
  };

  const handleCompareSimilar = () => {
    if (!product) return;
    addForCompare();
    onTrackCompare?.();
    navigate("/compare");
  };

  const handleQuickCompareFromTools = () => {
    if (!product) return;

    if (selectedProducts.some((p) => p._id === product._id)) {
      showToast?.({
        message: "This product is already in comparison",
        type: "info",
      });
      return;
    }

    if (selectedProducts.length >= maxComparableCount) {
      showToast?.({
        message: "Comparison is full (max 5 products)",
        type: "error",
      });
      return;
    }

    addCurrentProduct();
    showToast?.({
      message: "Product has been added to comparison",
      type: "success",
    });
  };

  return {
    handleCompareSimilar,
    handleQuickCompareFromTools,
  };
};

export default useProductComparisonActions;
